var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Logged in as "+_vm._s(_vm.displayName.userName)),_c('br'),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.auth.signOut()}}},[_vm._v("Sign Out")])])}
var staticRenderFns = []

export { render, staticRenderFns }